<template>
  <div>
    <div>
      <p>Color distinguishes our brand and helps us create consistent experiences across products. We choose primary, secondary, and extended colors that support usability by ensuring sufficient color contrast between elements so that people with low vision can see and use our products.</p>
    </div>
    <color-palette />
  </div>
</template>

<script>
import ColorPalette from './ColorPalette.vue'

export default {
  components: {
    ColorPalette,
  },
}
</script>
